export class ClothesEmployeSendModel {

    codbaan: string;
    descrp: string;
    cantd: number;
    disp: number;

    constructor() { }
}